import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import FormulaireSelectionDateHeureUnix from '../../ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
import FormulaireSelectUtsDate from '../../ProfilGraphe/FormulaireGraphe/FormulaireSelectUtsDate/FormulaireSelectUtsDate';
import Bouton from '../../../UI/Bouton/Bouton';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import { integerOrNull } from '../../../../ressources/functionJS/integerOrNull';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as actions from '../../../../services/actions';
import styles from '../../ProfilGraphe/FormulaireGraphe/FormulaireGraphe.module.scss';
import stylesD from './ChangementIntervalTempsGrapheAutomatique.module.scss';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';

const ChangementIntervalTempsGrapheAutomatique = ({
  afficherPopup,
  fermerPopupModifierIntervalle,
  affichageProfil,
  sensor_id,
  position_in_sensor,
}) => {
  const [timeInterval, setTimeInterval] = useState([null, null]);
  const [timePeriod, setTimePeriod] = useState(null);
  const [measuresNum, setMeasuresNum] = useState(null);
  const [selectTime, setSelectTime] = useState([]);
  const [inset, setInset] = useState('15% 10% 1% 30%');
  const [width, setWidth] = useState('700px');
  const [height, setHeight] = useState('500px');

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      window.screen.availWidth / 2 >= window.innerWidth ||
      window.screen.availHeight / 2 >= window.outerHeight
    ) {
      setInset('0 0 0 0');
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }
  }, []);

  const gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    if (name === 'time_period') setTimePeriod(value);
    if (name === 'measures_num') setMeasuresNum(value);
  };

  const gererDebut_time_interval = (unix) => {
    setTimeInterval([unix, timeInterval[1]]);
  };

  const gererFin_time_interval = (unix) => {
    setTimeInterval([timeInterval[0], unix]);
  };

  const gererConfigSelectUtsDate = (newConfigSelectUtsDate) => {
    setSelectTime([...newConfigSelectUtsDate]);
  };

  const reqRecupererDonneesGrapheAutomatiqueXT = () => {
    dispatch(
      actions.reqRecupererDonneesGrapheAutomatiqueXT(
        integerOrNull(sensor_id),
        integerOrNull(position_in_sensor),
        integerOrNull(timePeriod),
        integerOrNull(measuresNum),
        selectTime,
        timeInterval
      )
    );
  };

  return (
    <div>
      <Modal
        isOpen={afficherPopup}
        style={{
          overlay: {
            position: 'absolute',
            zIndex: '1000',
            overflowX: 'hidden',
            overflowY: 'hidden',
            border: 'black 1px solid',
            backgroundColor: 'transparent',
            transition: 'width 2s, height 4s',
          },
          content: {
            padding: '0px',
            overflowX: 'auto',
            width: width,
            height: height,
            inset: inset,
            boxShadow: '-5px 0px 5px rgba(0, 0, 0, 0.226)',
          },
        }}
        className={stylesD.ModalAdv}
        overlayClassName={stylesD.OverlayAdv}
        onRequestClose={fermerPopupModifierIntervalle}
      >
        <div className={[s.card_header, s.text_right].join(' ')}>
          <Bouton
            type={type_btn.fermer}
            rond={true}
            cliquer={fermerPopupModifierIntervalle}
          />
        </div>
        <div
          className={[s.container, s.text_left, styles.Formulaire].join(' ')}
        >
          <div className={s.form_group}>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <span className={s.col_12}>
                {checkMot('Interval de récupération de données [début, fin]')}
              </span>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={timeInterval[0]}
                  gereUnixDate={gererDebut_time_interval}
                  disabled={affichageProfil === true}
                />
              </div>
              <div className={s.col_6}>
                <FormulaireSelectionDateHeureUnix
                  value={timeInterval[1]}
                  gereUnixDate={gererFin_time_interval}
                  disabled={affichageProfil === true}
                />
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot(
                    'recuperation_des_donnees_sur_le_dernier_interval_de_temps_jusqu_a_present'
                  )}
                </span>
                <input
                  type="text"
                  pattern="[0-9a-zA-Z._%+-]+"
                  className={[s.form_control, s.mb_2].join(' ')}
                  placeholder="time_period"
                  name="time_period"
                  value={timePeriod || ''}
                  disabled={affichageProfil === true}
                  required
                  onChange={gererEtatDeCibleName}
                />
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot(
                    'recuperation_des_n_derniere_donnees_jusqu_a_present'
                  )}
                </span>
                <input
                  type="text"
                  pattern="[0-9]+"
                  className={[s.form_control, s.mb_2].join(' ')}
                  placeholder="measures_num"
                  name="measures_num"
                  value={measuresNum || ''}
                  disabled={affichageProfil === true}
                  required
                  onChange={gererEtatDeCibleName}
                />
              </div>
            </div>
          </div>

          <div className={s.form_group}>
            <div className={s.form_row}>
              <div className={s.col_12}>
                <span>
                  {checkMot('recuperation_des_donnees_des_dates_selectionnees')}
                </span>
                <FormulaireSelectUtsDate
                  preConfigSelectUtsDate={selectTime}
                  gererConfigSelectUtsDate={gererConfigSelectUtsDate}
                  disabled={affichageProfil === true}
                />
              </div>
            </div>
          </div>

          <Bouton cliquer={reqRecupererDonneesGrapheAutomatiqueXT}>
            {checkMot('changer_d_echantillon')}
          </Bouton>
        </div>
      </Modal>
    </div>
  );
};

export default ChangementIntervalTempsGrapheAutomatique;
